import store from '../store'
import axios from 'axios'
import {
  getToken
} from '../utils/auth'
import {
  removeToken
} from '../utils/auth'
import {
  mapGetters
} from 'vuex'
import {
  getMessage
} from "../api/commonApi";
// 创建axios实例
const service = axios.create({
  //	baseURL: process.env.BASE_API, // api的base_url
  // baseURL: "http://192.168.0.188:9002/lvbao",
  // baseURL: "http://192.168.0.115:8852/lvbao",
  //  阿里云服务器
  baseURL: "https://lb.blawsoft.com:8501/hwt"
  //fq
  // baseURL: "http://192.168.0.111:9002/lvbao",
  //	timeout: 5000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  // Do something before request is sent
  //config.headers['token'] = getToken() // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改

  if (window.require) { //如果是桌面程序 使用localStorage
    config.headers['token'] = localStorage.getItem('token')

  }else{//web端
    config.headers['token'] = getToken();
    // console.log(config.headers.token);
    sessionStorage.setItem('token', JSON.stringify(config.headers.token)); //将token存储于sessionStorage中  放于上传插件请求header中
  }


  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    // if (response.data.code == 401) {
    //   if (window.require) {//桌面程序的时候
    //     getMessage('您的身份信息已失效或已在其他地方登录...即将返回登录页面', 'error')
    //     setTimeout(() => {
    //       location.href = 'index.html'
    //     }, 2000);
    //   }else{//web端
    //     getMessage('您的身份信息已失效或已在其他地方登录...即将离开当前页面', 'error')
    //     removeToken();
    //     setTimeout(() => {
    //       location.href = '/'
    //     }, 2000);
    //   }
    // }
    return response;
  }, error => {
    // let loadingInstance = Loading.service(options);
    // 		this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
    // 			loadingInstance.close();
    // 		});
    console.log('err' + error) // for debu

    return Promise.reject(error)
  })

export default service



// WEBPACK FOOTER //
// ./src/utils/request1.js